import React from "react";
import styled from "styled-components";
import { Sheet } from "@mui/joy";

const Hello = styled.h1`
  margin: 0% auto;
  font-weight: 300;
  font-size: ${(props) => (props.size.width >= 800 ? "1.75vw" : "4vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
  display: inline-block;
  width: max-content;
`;

const HelloLink = styled.a`
  font-weight: 300;
  font-size: ${(props) => (props.size.width >= 800 ? "1.75vw" : "4vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
  display: inline-block;
  width: max-content;
  text-decoration: none;
  color: inherit;
  background: linear-gradient(
      to right,
      rgba(100, 200, 200, 0),
      rgba(100, 200, 200, 0)
    ),
    linear-gradient(
      to right,
      rgba(204, 0, 0, 1),
      rgba(204, 0, 0, 1),
      rgba(204, 0, 0, 1)
    );
  background-size: 100% 3px, 0 3px;
  background-position: 100% 100%, 0 100%;
  background-repeat: no-repeat;
  transition: background-size 400ms;
  &:hover {
    background-size: 0 3px, 100% 3px;
  }
`;

const FooterDescription = styled.div`
  margin: auto;
`;

const Footer = (props) => {
  const dynamicWidth = () => {
    if (props.size.width >= 900) {
      return (props.size.width * 3) / 5;
    } else if (props.size.width >= 600) {
      return (props.size.width * 4) / 5;
    } else {
      return (props.size.width * 6) / 7;
    }
  };

  const mainContainer = {
    borderRadius: 15,
    padding: 2,
    margin: "auto",
    marginTop: 2,
    marginBottom: 2,
    width: dynamicWidth(),
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px;",
    flexDirection: "column",
  };

  return (
    <Sheet sx={mainContainer}>
      <FooterDescription>
        <Hello size={props.size}>
          Made with ❤️ from scratch.&nbsp;
          <HelloLink size={props.size} href="https://www.github.com/sahnik1">
            Source Code
          </HelloLink>
        </Hello>
      </FooterDescription>
    </Sheet>
  );
};

export default Footer;
